'use client';

import { useEffect, useRef } from 'react';
import TurnstileWidget from '@/app/components/TurnstileWidget';

interface Props
{
  /** Pass the form's action state so the Turnstile widget resets after each submit attempt. */
  resetKey?: unknown;
}

/**
 * Hidden anti-spam fields shared by all contact forms:
 * - honeypot text input (`extra_info`) that humans never see,
 * - timestamp of when the form was mounted (`form_started_at`),
 * - invisible Cloudflare Turnstile widget.
 * The matching checks live in `src/lib/spam-guard.ts`.
 */
export default function FormAntiSpamFields({ resetKey }: Props) {
  const startedAtRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Set on the client only: the server-rendered value would be the (static) render time.
    if (startedAtRef.current) startedAtRef.current.value = String(Date.now());
  }, []);

  return (
    <>
      <div aria-hidden={ 'true' } className={ 'absolute -left-[10000px] top-0 h-0 w-0 overflow-hidden' }>
        <label>
          Doplňující informace
          <input type={ 'text' } name={ 'extra_info' } tabIndex={ -1 } autoComplete={ 'off' } defaultValue={ '' } />
        </label>
      </div>
      <input ref={ startedAtRef } type={ 'hidden' } name={ 'form_started_at' } defaultValue={ '' } />
      <TurnstileWidget className={ 'mt-2 empty:hidden' } resetKey={ resetKey } />
    </>
  );
}
